import { Button, Icon, Select, Tooltip } from '@hubtype/ui-react-web'
import { useState } from 'react'

import { TrackEventName, useAnalytics } from '../../../analytics'
import { useFlowBuilderSelector } from '../../../reducer/hooks'
import { headerDropdownProps } from '../header'
import { ComponentTitle, StyledFooter } from './locale-dropdown-styles'

export const LocaleDropdown = (): JSX.Element => {
  const analytics = useAnalytics()
  const [isOpen, setIsOpen] = useState<boolean | undefined>(undefined)
  const { state, toggleLocalesPanel, selectLocale } = useFlowBuilderSelector(
    ctx => ctx
  )
  const { isReadOnly, currentLocale, locales: stateLocales } = state

  const changeLocale = async (localeId?: string) => {
    const localeToSelect = stateLocales.find(locale => locale.code === localeId)
    if (localeToSelect) {
      selectLocale(localeToSelect)
      await analytics.trackEvent(TrackEventName.ChangeLanguage, {
        language_selected: localeToSelect.code,
      })
    }
  }

  const onOpenChange = (isOpen: boolean) => {
    setIsOpen(isOpen)
    if (!isOpen) return
    analytics.trackEvent(TrackEventName.LanguagesOpen, {
      number_of_languages: stateLocales.length,
      languages: stateLocales.map(locale => locale.getLocaleString()),
    })
  }

  const openLocalesPanel = () => {
    setIsOpen(false)
    analytics.trackEvent(TrackEventName.LanguagesAddRemoveCta)
    toggleLocalesPanel(true)
  }

  return (
    <Select
      {...headerDropdownProps}
      items={stateLocales}
      isOpen={isOpen}
      label={currentLocale.getLocaleString()}
      onChange={locale => changeLocale(locale?.code)}
      onOpenChange={onOpenChange}
      selectedKey={currentLocale?.code}
      renderButtonAsItem={true}
      header={
        <Tooltip
          placement='right top'
          content='Conversational apps can be available in multiple languages. Here you
        can manage translations but the conversation flow can’t be changed
        across different languages and every flow change you make will be
        applied to all languages.'
        >
          <ComponentTitle>
            Content languages
            <Icon icon='circle-question' size='tiny' />
          </ComponentTitle>
        </Tooltip>
      }
      footer={
        isReadOnly ? undefined : (
          <StyledFooter>
            <Button
              intent='secondary'
              size='small'
              appearance='outline'
              onPress={openLocalesPanel}
            >
              Add or remove languages
            </Button>
          </StyledFooter>
        )
      }
    >
      {item => <>{item.getLocaleString()}</>}
    </Select>
  )
}
